// import React, { useEffect, useState } from "react";
// import "./ImpactNumber.css";
// import BASE_URL from '../../config';
// import { Section5Config } from "../../models/Config";

// const ImpactNumbersForm = () => {
//   const [title, setTitle] = useState("Our Impact in Numbers");

//     const [config, setConfig] = useState(null);
//     const [loading, setLoading] = useState(true);

// useEffect(() => {
//   fetch(`${BASE_URL}/api/getImpactNumberConfig`)
//     .then((res) => res.json())
//     .then((data) => {
//         console.log("Section ==>", data);
//         const configObj = new Section5Config(data);
//         setConfig(configObj); // assume section_3 = candidate say
//         console.log("Section ==>", configObj);
//         setLoading(false);
//     });
// }, []);


//   if (loading) return <p>Loading...</p>;
//   if (!config) return <p>Failed to load section config</p>;

//   const handleNumberChange = (index, value) => {
//     const updatedConfig = [...config];
//     updatedConfig[index].number = value;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const sectionData = {
//       title,
//       config,
//     };
//     console.log("Impact Numbers Data:", sectionData);
//     alert("Numbers updated! Check console for details.");
//   };

//   return (
//     <div className="impact-form-card">
//       <h2 className="impact-form-title">Impact Numbers Section</h2>
//       <form onSubmit={handleSubmit}>
//         <div className="form-group">
//           <label>Section Title</label>
//           <input
//             type="text"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//           />
//         </div>

//         {config.stats.map((stat, index) => (
//           <div key={index} className="stat-item">
//             <label>{stat.description}</label>
//             <input
//               type="text"
//               value={stat.number}
//               onChange={(e) => handleNumberChange(index, e.target.value)}
//             />
//           </div>
//         ))}

//         <button type="submit" className="submit-btn">
//           Save Numbers
//         </button>
//       </form>
//     </div>
//   );
// };

// export default ImpactNumbersForm;

import React, { useEffect, useState } from "react";
import "./ImpactNumber.css";
// import BASE_URL from '../../config';
import { BASE_URL, GET_IMPACT_NUMBER_URL, ADD_UPDATE_IMPACT_NUMBER_URL } from "../../constants/Apis";

const ImpactNumbersForm = () => {
  const [title, setTitle] = useState("Our Impact in Numbers");
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}${GET_IMPACT_NUMBER_URL}`)
      .then(res => res.json())
      .then(data => {
        if (data.stats) {
          setTitle(data.title);
          setStats(data.stats);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading...</p>;

  const handleNumberChange = (index, value) => {
    const updatedStats = [...stats];
    updatedStats[index].number = value;
    setStats(updatedStats);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const sectionData = { title, stats };

    fetch(`${BASE_URL}${ADD_UPDATE_IMPACT_NUMBER_URL}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sectionData),
    })
      .then(res => res.json())
      .then(res => {
        if (res.success) alert("Impact numbers updated successfully!");
        else alert("Failed to update numbers");
      });
  };

  return (
    <div className="impact-form-card">
      <h2 className="impact-form-title">Impact Numbers Section</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Section Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {stats.map((stat, index) => (
          <div key={index} className="stat-item">
            <label>{stat.description}</label>
            <input
              type="text"
              value={stat.number}
              onChange={(e) => handleNumberChange(index, e.target.value)}
            />
          </div>
        ))}

        <button type="submit" className="submit-btn">
          Save Numbers
        </button>
      </form>
    </div>
  );
};

export default ImpactNumbersForm;
